import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// material ui core
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";

// Style
import { withStyles } from "@material-ui/core/styles";
import subscriptionCommon from "../Subscription/common";
import basketUtil from "../Subscription/basket";

class SubscriptionInfo extends React.Component {
  SubscriptionInfoRender = () => {
    return (
      <React.Fragment>
        <CssBaseline>
          <Typography variant="h5" gutterBottom>
            You have ...
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              xxxxxxxxxxxxxxxxxxx
            </Grid>
          </Grid>
          yyyyyyyyyyyyyyyyyyy
        </CssBaseline>
      </React.Fragment>
    );
  };

  render() {
    return this.SubscriptionInfoRender();
  }
}

SubscriptionInfo.propTypes = {};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

SubscriptionInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionInfo);

export default withStyles(subscriptionCommon.styles)(SubscriptionInfo);
